"use strict";
// This static module is for Api Endpoint list that required token x ARC-15808

var EndpointStaticModule = (function () {
    return {
        Get: function () {
            // Example: api/v2/merchants/id/shipping-methods/sid === id is merchantId or userId and sid is sub id
            return {
                Admin: [
                    // Admin token for this endpoint xxx for multiple request method (ex: GET, POST, DEL, PUT) in single endpoint
                    "/api/v2/merchants/id/shipping-methods", // Item page
                    "/api/v2/users/id/carts", // Header
                    "/api/v2/merchants/id/payment-terms", // Item page
                    "/api/v2/users/id/addresses", // Search page
                    "/api/v2/admins/id/transactions", // Checkout page
                    "/api/v2/admins/id/transactions/sid", // Checkout page
                    "/api/v2/admins/id/payment-gateways", // Checkout page
                    "/api/v2/merchants/id/payment-acceptance-methods", // Checkout page
                    "/api/v2/merchants/id/reports", // Storefront page
                    "/api/v2/merchants/id/analytics", // Storefront page
                    "/api/v2/admins/id/users/sid/roles/Merchant", // Become a provider
                    "/api/v2/admins/id/orders", // Checkout page
                    "/api/v2/merchants/id/invoices/sid", // Checkout page
                    "/api/v2/admins/id/invoices/sid", // Checkout page
                    "/api/v2/users/id/channels/sid", //Chat Channels
                    "/api/v2/users/id/channels", //Chat Channels
                    "/api/v2/users/id", // Profile page
                    "/api/v2/users/id/comparisons", //Storefront page
                    "/api/v2/users/id/comparisons/sid", // Storefront page
                    "/api/v2/users/id/activities/page", //Chat Channels
                    "/api/v2/users/id/get-user-permissions", 
                    "/api/v2/users/id/wishlist",
                    "/api/v2/merchants/id/items/sid", //Stripewebhook
                    "/api/v2/merchants/id/items/save-promoted-item", //Stripewebhook
                    "/api/v2/users/id/carts",
                    "/api/v2/users/id/carts/sid",
                    "/api/v2/feedback/sid",
                    "/api/v2/admins/id/feedback/search", 
                ],
                Post: [
                    // Admin token for POST method endpoint only
                    "/api/v2/merchants/id/transactions", // Purchase Order page
                    "/api/v2/users/id/transactions/sid",
                    "/api/v2/sso",
                    "/api/v2/users/id/carts",
                    "/api/v2/users/id/carts/sid",
                    "/api/v2/users/id/media", // Profile image upload
                ],
                Required: [
                    // Endpoint for not currently login or no webapitoken in cookie xxxx token use is admin


                    // '/api/v2/merchants/id/analytics', // Storefront page
                    // '/api/v2/merchants/id/reports', // Storefront page
                    "/api/v2/users/id/activities/login", // Login page
                    "/api/v2/users", // Login page
                    "/api/v2/accounts/register", // Registration page
                    "/api/v2/admins/id/users", // Forgot password page
                ],
            };
        },
    };
})();

module.exports = EndpointStaticModule;
